var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgNotificationIconAccount = function SvgNotificationIconAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#26E5E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15.33 9.288c.048 1.865-1.406 3.417-3.246 3.467-1.84.05-3.37-1.422-3.417-3.287C8.62 7.603 10.073 6.05 11.914 6c1.84-.05 3.37 1.422 3.417 3.287z",
    stroke: "#191919",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 17.25S14.9 14.685 12 14.685 6.75 17.25 6.75 17.25",
    stroke: "#191919",
    strokeWidth: 1.8
  })));
};
export default SvgNotificationIconAccount;